import type { ExcelCompatibleTableData } from "../../../../utils/files/downloadAsExcel";

export function getExportFileDatesPostfix(
  tableData: ExcelCompatibleTableData
): string {
  const firstDate = tableData[2][0]; // skip header rows, take first data row (3rd row)
  const lastDate = tableData.at(-2)?.[0]; // skip footer row, take last data row

  return `${firstDate}-${lastDate}`;
}
